import { toast } from 'react-toastify';
export const successAlert = (alertMessage, duration = 3000) => {
  toast.success(alertMessage || 'Success!', {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: duration,
    closeOnClick: true
  });
};

export const errorAlert = (alertMessage, duration = 3000) => {
  toast.error(alertMessage || 'Something went wrong!', {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: duration,
    closeOnClick: true
  });
};

export const infoAlert = (alertMessage, duration = 3000) => {
  toast.info(alertMessage || 'Information!', {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: duration,
    closeOnClick: true
  });
};
